var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBannerManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6624 13.3333L7.6788 10.5133L8.6928 13.3333H6.6624ZM16.8 12H18V14.6667H16.8C16.4817 14.6667 16.1765 14.5262 15.9515 14.2761C15.7264 14.0261 15.6 13.687 15.6 13.3333C15.6 12.9797 15.7264 12.6406 15.9515 12.3905C16.1765 12.1405 16.4817 12 16.8 12ZM22.8 0H1.2C0.88174 0 0.576515 0.140476 0.351472 0.390524C0.126428 0.640573 0 0.979711 0 1.33333V22.6667C0 23.0203 0.126428 23.3594 0.351472 23.6095C0.576515 23.8595 0.88174 24 1.2 24H22.8C23.1183 24 23.4235 23.8595 23.6485 23.6095C23.8736 23.3594 24 23.0203 24 22.6667V1.33333C24 0.979711 23.8736 0.640573 23.6485 0.390524C23.4235 0.140476 23.1183 0 22.8 0ZM12.7176 17.3333H10.1316L9.6516 16H5.7036L5.2236 17.3333H2.6388L4.0776 13.336L4.0788 13.3333L6.4788 6.66667H8.8788L12.7176 17.3333ZM18 6.66667H20.4V17.3333H16.8C15.8452 17.3333 14.9295 16.9119 14.2544 16.1618C13.5793 15.4116 13.2 14.3942 13.2 13.3333C13.2 12.2725 13.5793 11.2551 14.2544 10.5049C14.9295 9.75476 15.8452 9.33333 16.8 9.33333H18V6.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBannerManager);
export default __webpack_public_path__ + "static/media/IconBannerManager.da143c28f95e5988e7321d2d14e8dee1.svg";
export { ForwardRef as ReactComponent };